export const money = (n) =>
  `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const MAX_QTY = 240;
export const QTY_STEP = 12;
export const QTY_OPTIONS = [1, ...Array.from({ length: MAX_QTY / QTY_STEP }, (_, i) => (i + 1) * QTY_STEP)];
export const GRID_QTYS = [1, 12, 24, 48, 72, 96, 120, 144, 192, 240];

// Snap any typed number to a valid quantity: 1, or the next multiple of 12, capped.
export function snapQty(n) {
  const q = Math.max(1, Math.floor(Number(n) || 1));
  if (q === 1) return 1;
  return Math.min(MAX_QTY, Math.ceil(q / QTY_STEP) * QTY_STEP);
}

// Mirrors backend: unit = a + b/qty fitted through the 12 & 48 tiers; qty 1 uses the 1-tier price.
export function unitPriceAt(pm, cell, qty) {
  const row = pm?.cells?.[cell];
  if (!row) return null;
  const [c1, c2] = pm.curve_tiers || [pm.tiers[1], pm.tiers[2]];
  const p1 = row[pm.tiers.indexOf(c1)], p2 = row[pm.tiers.indexOf(c2)];
  if (qty < c1) return row[0];
  const b = (p1 - p2) / (1 / c1 - 1 / c2);
  return (p2 - b / c2) + b / qty;
}

export function addBusinessDays(start, days) {
  const d = new Date(start);
  let left = days;
  while (left > 0) {
    d.setDate(d.getDate() + 1);
    const w = d.getDay();
    if (w !== 0 && w !== 6) left -= 1;
  }
  return d;
}

export function deliveryEstimate(turnaround) {
  const m = /(\d+)(?:\s*-\s*(\d+))?/.exec(turnaround?.business_days || "");
  const prod = m ? Number(m[2] || m[1]) : 7;
  const eta = addBusinessDays(new Date(), prod + 3);
  return eta.toLocaleDateString("en-US", { month: "2-digit", day: "2-digit" });
}
